import { parsePhoneNumber } from "libphonenumber-js";

export const capitalizeFirstLetter = (label: string) =>
  (label && label[0].toUpperCase() + label.slice(1)) || "";

const getCountryCodeUnlessExists = (phoneNumber: string) =>
  phoneNumber.slice(0, 1) !== "+" ? `+1${phoneNumber}` : phoneNumber;

export const formatPhoneNumber = ({
  phoneNumber,
  showCountryCode = false,
}: {
  phoneNumber: string;
  showCountryCode?: boolean;
}) => {
  if (phoneNumber === "") return "";
  const safePhoneNumber = getCountryCodeUnlessExists(phoneNumber);

  try {
    const phone = parsePhoneNumber(safePhoneNumber);
    const formattedNumber = showCountryCode
      ? `+${phone.countryCallingCode} ${phone.formatNational()}`
      : phone.formatNational();

    return formattedNumber;
  } catch {
    return "";
  }
};

export const toTitleCase = (word: string) =>
  word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word;
